// extracted by mini-css-extract-plugin
export default {"userQr":"Qr_userQr__CEVcU","qrContainer":"Qr_qrContainer__75ToZ"};